export default __webpack_public_path__ + "static/media/flat-email.af28de4e.svg";